import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class CampaignService {

  private _apiUrl = '/api/Campaign';
  private _apiURLChat = '/api/Chat';
  private _apiURLMobile = '/api/Mobile';
  private _clubUrl = '/api/Club';

  constructor(private _http: HttpService, private _httpClient: HttpClient) { }


  getClubCampaignsByClubId(clubId: number) {
    return this._http.get(`${this._apiUrl}/get-club-campaigns-by-club-id/${clubId}`);
  }

  getClubCampaignStatsByClubId(clubId: number) {
    return this._http.get(`${this._apiUrl}/get-club-campaign-stats-by-club-id/${clubId}`);
  }

  getClubTeamsByClubId(clubId: number) {
    return this._http.get(`${this._apiUrl}/get-club-teams-by-club-id/${clubId}`);
  }

  getUserNameAndAvatarList(userIDList) {
    var UserIDListVM = { UserIDList: userIDList };
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', responseType: 'text' })
    };
    return this._httpClient.post(this._apiURLChat + '/get-users-name-and-avatar-by-userID/', UserIDListVM, httpOptions);
  }

  getTeamNameAndLogoList(teamIDList) {
    var TeamIDListVM = { TeamIDList: teamIDList };
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', responseType: 'text' })
    };
    return this._httpClient.post(this._apiURLChat + '/get-team-name-and-logo-by-teamIDList/', TeamIDListVM, httpOptions);
  }

  getClubCampaignSubscribersById(campaignId: number) {
    return this._http.get(`${this._apiUrl}/get-club-campaign-subscribers-by-id/${campaignId}`);
  }

  getClubMessageReminderLogDetailsById(messageReminderSentLogID: number) {
    return this._http.get(`${this._apiUrl}/get-club-message-reminder-sent-log-details-by-id/${messageReminderSentLogID}`);
  }

  getClubCampaignSubscriberEmailHistoryById(campaignSubscriberId: number) {
    return this._http.get(`${this._apiUrl}/get-club-campaign-subcriber-email-history-by-id/${campaignSubscriberId}`);
  }

  getClubCampaignEmailTemplate(campaignID: number) {
    return this._http.get(`${this._apiUrl}/get-club-campaign-email-template/${campaignID}`);
  }

  createCampaign(payload: any, clubId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(this._apiUrl + '/create-campaign/' + clubId,
      payload,
      httpOptions
    );
  }

  createCampaignTemplate(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(this._apiUrl + '/create-campaign-template/',
      payload,
      httpOptions
    );
  }

  updateCampaignTemplate(payload: any, id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(this._apiUrl + '/update-campaign-template/' + id,
      payload,
      httpOptions
    );
  }


  getCampaignEmailTemplatesByClubId(clubId: number) {
    return this._http.get(`${this._apiUrl}/get-campaign-email-templates-by-club-id/${clubId}`);
  }

  getCampaignEmailTemplateById(templateId: number) {
    return this._http.get(`${this._apiUrl}/get-campaign-email-template-by-id/${templateId}`);
  }

  deleteEmailTemplates(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        TemplateIDList: ids,
      }
    };
    return this._http.delete(this._apiUrl + '/delete-campaign-email-templates/', httpOptions);
  }

  getClubCampaignSubscribersWithCount(payload: any) {
    //const httpOptions = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/json',
    //    responseType: 'text'
    //  })
    //};
    return this._httpClient.post(this._apiUrl + '/get-club-campaign-subscribers-with-count/', payload);
  }

  createCampaignData(payload: any) {
    return this._http.post(this._apiUrl + '/create-campaign/', payload);
  }

  deleteClubCampaign(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        CampaignIDList: ids,
      }
    };
    return this._http.delete(this._apiUrl + '/delete-club-campaign/', httpOptions);
  }
  
  deleteTgsClubArticle(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this._http.post(this._apiURLMobile + '/delete-tgs-club-article/', obj);
  }

  getClubTeamMessagesGroups(clubId: number, teamID: number, userID: number, isTeamAccount: boolean) {
    return this._http.get(`${this._apiURLChat}/get-team-message-groups/${clubId}/${teamID}/${userID}/${isTeamAccount}`);
  }

  getChatDetails(FBTeamMessageGroupID, currentUserId, IsLoadMoreVisible, IsBusy, PageIndex, PageSize) {
    return this._http.get(`${this._apiURLChat}/get-chat-details/${FBTeamMessageGroupID}/${currentUserId}/${IsLoadMoreVisible}/${IsBusy}/${PageIndex}/${PageSize}`);
  }

  getTeamChatDetails(FBTeamMessageGroupID, currentUserId) {
    //console.log("called function getTeamChatDetails()");
    return this._http.get(`${this._apiURLChat}/get-team-chat-details/${FBTeamMessageGroupID}/${currentUserId}`);
  }

  createTeamChatMessage(payload: any) {
    return this._http.post(this._apiURLChat + '/create-team-chat-message/', payload);
  }

  getClubParentAndStaffList(clubID, teamID) {
    return this._http.get(this._apiURLMobile + `/get-club-parent-and-staff-list-for-communication/${clubID}/${teamID}`);
    //return this._http.get(this._apiURLMobile + `/get-club-parent-and-staff-list/${clubID}/${teamID}`);
  }

  getAutomatedEmailsReports(clubID: number, teamID: number, emailTypeFlag: number) {
    return this._http.get(`${this._apiUrl}/get-automated-emails-reports/${clubID}/${teamID}/${emailTypeFlag}`);
  }

  getClubParentChildList(clubID, teamID) {
    return this._http.get(this._apiURLChat + `/get-club-parent-child-list/${clubID}/${teamID}`);
  }

  getTGSClubArticleListForMobile(clubId: number, isPublished) {
    return this._http.get(`${this._apiURLMobile}/get-tgs-club-article-list-mobile/${clubId}/${isPublished}`);
  }
  createArticleData(payload: any) {
    //if (payload.TgsClubArticleID > 0) {
    //  var obj = [{
    //    ArticleID: payload.TgsClubArticleID,
    //    Featured: payload.Featured
    //  }]
    //  ;
    //  return this._http.post(this._apiURLMobile + '/update-tgs-club-article-featured-status/', obj);
    //} else {
    return this._http.post(this._apiURLMobile + '/save-tgs-club-article/', payload);
    //}
  }
  getTgsMarketingCampaignListByCriteria(payload: any) {
    return this._httpClient.post(this._apiUrl + '/get-club-marketing-campaign-list-by-criteria/', payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/campaign.service.ts